import * as React from 'react';

function Rab(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16" {...props}>
      <path d="M15.755 16H0L2.76 0h15.756l-2.76 16z" fill="#00FFB7" />
      <path
        d="M14.49 6.726h-3.72L11.2 4.21 8.848 2.94l-.655 3.786H5.717L4.015 9.342h3.73L7.31 11.85l2.357 1.27.652-3.777h2.468l1.702-2.616z"
        fill="black"
      />
    </svg>
  );
}

export default Rab;
